import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleChange: function handleChange(e) {
      /* let num = e.target.value */

      var num = e;
      num = parseInt(num);
      /* if(num > this.max) {
      this.$emit('input', this.max)
      return
      * }
      * if (num < this.min){
      this.$emit('input', this.min)
      return
      * } */
      this.$emit('input', num);
    }
  }
};